// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

function useTriggerAfterTimeout(dependenciesOpt, test, timeout, timeoutTriggeredCallback) {
  var dependencies = dependenciesOpt !== undefined ? dependenciesOpt : [];
  React.useEffect((function () {
          var startTimer = function () {
            return setTimeout((function () {
                          if (test()) {
                            return timeoutTriggeredCallback();
                          }
                          
                        }), timeout);
          };
          var id = test() ? Caml_option.some(startTimer()) : undefined;
          return Belt_Option.flatMap(id, (function (id) {
                        return (function () {
                                  clearTimeout(id);
                                });
                      }));
        }), dependencies);
}

function seconds(sec) {
  return Math.imul(sec, 1000);
}

export {
  useTriggerAfterTimeout ,
  seconds ,
}
/* react Not a pure module */
